import { jsx } from "react/jsx-runtime";
import { B as Box } from "./Grid-CcQKdsgp.js";
import { Overlay } from "@react-aria/overlays";
const UIKitOverlay = ({
  children,
  portalContainer,
  ...props
}) => {
  return /* @__PURE__ */ jsx(Overlay, { portalContainer, children: /* @__PURE__ */ jsx(Box, { ...props, children }) });
};
export {
  UIKitOverlay as U
};
